export default "__VITE_ASSET__ea7327f4__"